var __flash__toXML = function __flash__toXML(obj) {
    var xml;
    switch (typeof obj) {
        case 'boolean':
            return obj ? '<true/>' : '<false/>';
        case 'number':
            return '<number>' + obj + '</number>';
        case 'object':
            if (obj === null) {
                return '<null/>';
            }
            if ('hasOwnProperty' in obj && obj.hasOwnProperty('length')) {
                // array
                xml = '<array>';
                for (var i = 0; i < obj.length; i++) {
                    xml += '<property id="' + i + '">' + __flash__toXML(obj[i]) + '</property>';
                }
                return xml + '</array>';
            }
            xml = '<object>';
            for (var key in obj) {
                xml += '<property id="' + key + '">' + __flash__toXML(obj[key]) + '</property>';
            }
            return xml + '</object>';
        case 'string':
            return '<string>'
                + obj.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                + '</string>';
        case 'undefined':
            return '<undefined/>';
    }
};
var ExternalInterfaceService = /** @class */ (function () {
    function ExternalInterfaceService() {
    }
    Object.defineProperty(ExternalInterfaceService, "interfaceID", {
        get: function () {
            return ExternalInterfaceService._interfaceID;
        },
        set: function (value) {
            ExternalInterfaceService._interfaceID = value;
        },
        enumerable: false,
        configurable: true
    });
    ExternalInterfaceService.ensureInit = function () {
        if (!window[ExternalInterfaceService._interfaceID])
            window[ExternalInterfaceService._interfaceID] = {};
        window[ExternalInterfaceService._interfaceID]['__flash__toXML'] = __flash__toXML;
    };
    ExternalInterfaceService.initJS = function (callback) {
        ExternalInterfaceService.callback = callback;
    };
    ExternalInterfaceService.registerCallback = function (functionName) {
        ExternalInterfaceService.ensureInit();
        window[ExternalInterfaceService._interfaceID][functionName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return ExternalInterfaceService.callback(functionName, args);
        };
    };
    ExternalInterfaceService.unregisterCallback = function (functionName) {
        ExternalInterfaceService.ensureInit();
        delete window[ExternalInterfaceService._interfaceID][functionName];
    };
    ExternalInterfaceService.eval = function (expression) {
        ExternalInterfaceService.ensureInit();
        try {
            return window.eval(expression);
        }
        catch (e) {
            console.warn('[ExternalInterfaceService] Eval crashed:\n', expression, '\n' + e.message);
        }
    };
    ExternalInterfaceService.call = function (request) {
        // ...
    };
    ExternalInterfaceService.getId = function () { return null; };
    ExternalInterfaceService.enabled = true;
    ExternalInterfaceService._interfaceID = 'flash';
    return ExternalInterfaceService;
}());
export { ExternalInterfaceService };
